import { Controller } from "@hotwired/stimulus"

export default class extends Controller { 

  connect() {
    parent.postMessage({ message: "notifications_badge_controller:connect" }, "*");
  }
}